<span class="relative flex flex-col w-full h-full">
    <div class="p-8 pb-6" mat-dialog-content>
        <ng-container>
            <div class="absolute top-0 right-0 pt-4 pr-4">
                <button (click)="close()" mat-icon-button>
                    <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                </button>
            </div>
        </ng-container>
        <ng-container>
            <h2 class="text-2xl font-semibold mb-4">Niðurstöður fyrir stofnun og sendingu reikninga</h2>
            <div class="mb-4">
                <strong>Fjöldi færsla sem átti að stofna reikning fyrir:</strong>
                {{ data?.numberOfTotalClaims }}
            </div>
            <div class="mb-4">
                <strong>Fjöldi reikninga sem stofnuðust og voru sendir í BC:</strong>
                {{ data?.numberOfSuccessfullyCreatedInvoices }}
            </div>
            <div class="mb-4">
                <strong>Fjöldi reikninga sem lentu á villu:</strong>
                {{ data?.failedClaimInvoiceRequests?.length ?? 0 }}
            </div>
        </ng-container>
        <div *ngIf="data?.failedClaimInvoiceRequests?.length > 0">
            Til að sjá nánari upplýsingar um villur, smelltu á hnappinn hér fyrir neðan til að sækja niðurstöður sem CSV skrá.
        </div>
        <div class="float-left w-100 mt-2">
            <div class="flex items-center justify-end mt-2 mb-2">
                <button class="ml-1" (click)="saveCSVFile()" mat-flat-button type="submit" [color]="'primary'">
                    <span> Sækja niðurstöður sem CSV </span>
                </button>
            </div>
        </div>
    </div>
</span>
